import { gql } from '@apollo/client'
import { BaseBlock, BlockFragment } from '../blocks.types'

export const FaqsBlockFragment: BlockFragment = {
  name: 'faqs',
  fragment: gql`
    fragment faqs on Faqs {
      id
      blockName
      blockType
      faqs {
        id
        question
        answer
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
  partialFragment: `
    ...on Faqs {
      id
      blockName
      blockType
      faqs {
        id
        question
        answer
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
}

export const FaqsBlockType = 'faqs'

export interface FaqsBlock extends BaseBlock {
  blockType: typeof FaqsBlockType
  alignment: string
  faqs: {
    id: string
    question: string
    answer: any[]
  }[]
}
